import { List, Map } from 'immutable';

import {
	GOTO_STEP,
	GOTO_PREV_STEP,
	GOTO_NEXT_STEP,
	SET_CONVENTION,
	SET_PRIVACY_INFO,
	SET_PRODUCTS
} from './actionDefinitions';

const stepInitialState = 1; // start from step 1

const step = (state = stepInitialState, action) => {
	switch(action.type) {
		case GOTO_STEP:
			return action.payload.step;
		case GOTO_PREV_STEP:
			return state - 1;
		case GOTO_NEXT_STEP:
			return state + 1;
		default:
			return state;
	}
};

const productsInitialState = new Map({
	products: new List([]),
	privacyInfo: false,
	convention: new Map({
		name: '',
		validity: false
	})
});

const productsDetails = (state = productsInitialState, action) => {
	switch(action.type) {
		case SET_PRODUCTS:
			return state.set('products', new List(action.payload.products));
		case SET_CONVENTION:
			return state.setIn(['convention', 'name'], action.payload.name).setIn(['convention', 'validity'], action.payload.validity);
		case SET_PRIVACY_INFO:
			return state.set('privacyInfo', action.payload);
		default:
			return state;
	}
};

export { step, productsDetails };
